/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateOrganizationChatSettingRequestOrganizationChatSettingFromJSON, UpdateOrganizationChatSettingRequestOrganizationChatSettingToJSON } from './UpdateOrganizationChatSettingRequestOrganizationChatSetting';
export function UpdateOrganizationChatSettingRequestFromJSON(json) {
    return UpdateOrganizationChatSettingRequestFromJSONTyped(json, false);
}
export function UpdateOrganizationChatSettingRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        organizationChatSetting: !exists(json, 'organization_chat_setting')
            ? undefined
            : UpdateOrganizationChatSettingRequestOrganizationChatSettingFromJSON(json['organization_chat_setting'])
    };
}
export function UpdateOrganizationChatSettingRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        organization_chat_setting: UpdateOrganizationChatSettingRequestOrganizationChatSettingToJSON(value.organizationChatSetting)
    };
}
